const roles = {
  ADMIN: "ADMIN",
  TEACHER: "TEACHER",
  STAFF: "STAFF",
  STUDENT: "STUDENT",
};

export default roles;
